enum NotificationType {
  INFO = "INFO",
  ERROR = "ERROR",
}

export default NotificationType;
